import Ucc3 from './Ucc3';

export default Ucc3;
